// extracted by mini-css-extract-plugin
export default {"container":"Map_container__BonMS","map":"Map_map__obQCL"};